
  import Events from '@/events/Events';
  import {prepareApiUrl} from '@/helper/UrlHelper';
  export default {
    components: {
      FavorJobPostingButton: () => import('@/components/FavorJobPostingButton'),
      JobCardBadges: () => import('@/components/elements/JobCardBadges'),
      RegisterAndApplyButton: () =>
        import('@/components/RegisterAndApplyButton'),
      ApplyOnJobPostingDialog: () =>
        import('@/components/candidate/ApplyOnJobPostingDialog'),
    },
    props: {
      job: {
        type: Object,
        required: true,
      },
      application: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      favorite: {
        type: Object,
        required: false,
        default: () => ({}),
      },
    },
    computed: {
      logoUrl() {
        return prepareApiUrl(process.env.NUXT_ENV_API_JOB_POSTING_LOGO, {
          routeParameters: {
            id: this.job.id,
          },
          getParameters: {},
        });
      },
      hasApplication() {
        return Object.keys(this.application).length > 0;
      },
      hasFavorite() {
        return Object.keys(this.favorite).length > 0;
      },
      applicationDialog() {
        return (
          !!this.$route.query.application &&
          Object.keys(this.application).length === 0
        );
      },
      openApplicationDialog() {
        return (
          this.$route.query.openApplicationDialog &&
          Object.keys(this.application).length === 0
        );
      },
    },
    methods: {
      clickApplicationWebhook() {
        this.$emitWithClientData(Events.JobApplicationClickedFromDetails, {
          jobPostingId: this.job.id,
          type: 'JobDetails',
        });
      },
    },
  };
